export default "__VITE_ASSET__D4h4IXVV__"